import React from "react";
import { createRoot } from 'react-dom/client';
import { AuthProvider } from 'react-oidc-context';
import { oidcConfig } from './auth/oidc';
import App from "./App";
import ErrorBoundary from "./components/ErrorBoundary";
import './styles/global.css';

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <ErrorBoundary
      fallbackTitle="Error crítico de la aplicación"
      fallbackMessage="Ha ocurrido un error crítico. Por favor, recarga la página o contacta al administrador del sistema."
    >
      <AuthProvider {...oidcConfig}>
        <App />
      </AuthProvider>
    </ErrorBoundary>
  </React.StrictMode>
);
